import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";
import { COLLECTIONS } from "@/lib/site";

const seen = new Set();
const BROCHURES = Object.values(COLLECTIONS)
  .map((c) => c.brochure)
  .filter((b) => b && !seen.has(b.url) && seen.add(b.url));

export default function Brochures() {
  return (
    <>
      <PageHead
        eyebrow="Resources"
        titleLines={["Brochures", "& downloads."]}
        intro="Browse and download the full House of David collection brochures in one place."
      />

      <section className="edge pb-28 md:pb-40" data-testid="brochures-grid">
        <div className="grid grid-cols-1 gap-x-10 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          {BROCHURES.map((b, i) => (
            <Reveal key={b.url} delay={(i % 3) * 0.06}>
              <div className="group" data-testid={`brochure-card-${i}`}>
                <a
                  href={b.url}
                  target="_blank"
                  rel="noreferrer"
                  className="block overflow-hidden border border-border/60 bg-secondary/40"
                >
                  <img
                    src={b.url.replace(/\.pdf$/i, "-cover.jpg")}
                    alt={`${b.name} cover`}
                    className="aspect-[3/4] w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
                    loading="lazy"
                  />
                </a>
                <div className="mt-5 flex items-baseline justify-between hairline pt-4">
                  <h3 className="text-lg font-light tracking-editorial">{b.name}</h3>
                </div>
                <div className="mt-3 flex gap-8">
                  <a
                    href={b.url}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`brochure-view-${i}`}
                    className="border-b border-foreground pb-1 text-xs uppercase tracking-[0.16em]"
                  >
                    View →
                  </a>
                  <a
                    href={b.url}
                    download
                    data-testid={`brochure-download-${i}`}
                    className="border-b border-foreground pb-1 text-xs uppercase tracking-[0.16em]"
                  >
                    Download ↓
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
